<kody-chip *ngIf="storeItem.tags" color="primary">
  {{ storeItem.tags }}
</kody-chip>
<kody-chip color="success" *ngIf="storeItem.isVegan || storeItem.isVegetarian">
  {{ storeItem.isVegan ? 'Ve' : 'V' }}
</kody-chip>
<kody-chip color="success" *ngIf="storeItem.isGlutenFree"> Gf </kody-chip>
<kody-chip color="danger" *ngIf="storeItem.isEighteenPlus"> 18+ </kody-chip>
